// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomButton_container__2NwIc","red":"CustomButton_red__Yw9Ha","btnTitle":"CustomButton_btnTitle__1p-b6"};